import { memo } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

import './LoadingSpinner.css';

type LoadingSpinnerProps = {
  color?: string;
  size?: number;
  loading: boolean;
};

export const LoadingSpinner = memo(
  ({ color = '#fff', size = 100, loading }: LoadingSpinnerProps) => {
    return (
      <div className="overlay">
        <ClipLoader loading={loading} size={size} color={color} />
      </div>
    );
  },
);
